import types from '../mutation-types';
import ContactVisibilityApi from '../../api/contactVisibility';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { CONTACT_VISIBILITY_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  visible: true,
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  isVisible: _state => _state.visible,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  async fetch({ commit }) {
    commit(types.SET_CONTACT_VISIBILITY_UI_FLAG, { isFetching: true });
    try {
      const response = ContactVisibilityApi.get();
      commit(types.SET_CONTACT_VISIBILITY, response.data.visible);
      return response.data; // Return the data from the API
    } catch (error) {
      return { error: error.message };
    } finally {
      commit(types.SET_CONTACT_VISIBILITY_UI_FLAG, { isFetching: false });
    }
  },

  async update({ commit }, updateObj) {
    commit(types.SET_CONTACT_VISIBILITY_UI_FLAG, { isUpdating: true });
    try {
      const response = await ContactVisibilityApi.update(updateObj);
      AnalyticsHelper.track(CONTACT_VISIBILITY_EVENTS.UPDATE);
      commit(types.SET_CONTACT_VISIBILITY, response.data.visible);
    } catch (error) {
      throw new Error(error?.response?.data?.message);
    } finally {
      commit(types.SET_CONTACT_VISIBILITY_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_VISIBILITY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONTACT_VISIBILITY](_state, visible) {
    _state.visible = visible;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
